import * as React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PlayVideo from "../../Play/custom-video";
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "@StarberryUtils"
import gql from "graphql-tag"
import { useQuery } from '@apollo/client';
import moment from 'moment'

//import ScrollAnimation from "react-animate-on-scroll";
import { LATEST_NEWS_PAGE_URL } from "../../common/site/constants";
import ImageTransform from "../../common/ggfx-client/module/components/image-transform";
import ImageModule from "../../common/Image_Module";

import Slider from "react-slick";
import "./Videos.scss"

const Videos = (props) => {
    const data = useStaticQuery(graphql`
    query {
        glstrapi {
            videos {
              id
              Featured              
              createdAt
              Title
              Embed_Video_URL
              Image {
                alternativeText
                url
              }
              video_categories {
                id
                Name
                URL
              }
              
            }
          }
    }
  `);
    //let [isPlay, setPlay] = React.useState(false); 
    let [videoURL, setvideoURL] = React.useState("");
    const videos = data.glstrapi.videos;
    var allvideos = videos;
    if (props.category !== null) {
        allvideos = videos.filter(video => {
            let category = video.video_categories.filter(cat => cat.URL === props.category.item);
            return category.length > 0
        });
    }
    const featuredVideos = allvideos.filter(video => video.Featured === true);
    const videosList = allvideos.filter(video => video.Featured === false); 
    return (
        <section class="news-page">
            <div animateIn='fadeInUp' animateOnce className="news">
                <Container className="pad-50 featured-properties">
                    <Row>
                        {featuredVideos && featuredVideos.map((video, index, active) => {
                          const image_url = video.Image.url 

                          let processedImages = JSON.stringify({});
                          if (video?.imagetransforms?.Image_Transforms) {
                              processedImages = video.imagetransforms.Image_Transforms;
                          }
                            return (
                                <div className="all-products feature-video-list featured-news col-lg-6 col-md-6">
                                    <div className="properties-wrapper img-zoom">
                                        {/* <ImageTransform 
                                        imagesources={image_url} 
                                        renderer="srcSet" 
                                        imagename="news-items.Tile_Image.tile_1" 
                                        attr={{ alt: video.Title+ ' - Dacha', class:'' }} 
                                        imagetransformresult={processedImages} 
                                        id={video.id}/> */}
                                         <ImageModule 
                                                ImageSrc={video?.Image } 
                                                attr={{ alt: video?.Title +'Off Plan Gallery - Dacha', class: '' }} 
                                                ggfx_results={video?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_1"
                                                strapi_id={video?.id} 
                                        />    
                                        {video.Embed_Video_URL &&
                                            <div className="banner-btn">
                                                <PlayVideo url={video.Embed_Video_URL}  
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className="newsletter-info">
                                        {video.createdAt &&
                                        <div className="time-info">
                                            <i className="icon-clock">
                                            </i>
                                            {moment(video.createdAt).format("DD/MM/YYYY")}
                                        </div>
                                        }
                                        <h4>{video.Title}  </h4>
                                    </div>
                                </div>
                            )
                        })}
                    </Row>
                    <Row>
                        {videosList && videosList.map((video, index, active) => {
                          const image_url = video.Image.url 

                          let processedImages = JSON.stringify({});
                          if (video?.imagetransforms?.Image_Transforms) {
                              processedImages = video.imagetransforms.Image_Transforms;
                          }
                            return (
                                <div className="all-products video-list col-lg-3 col-md-6">
                                    <div className="properties-wrapper img-zoom">
                                        {/* <ImageTransform 
                                        imagesources={image_url} 
                                        renderer="srcSet" 
                                        imagename="news-items.Tile_Image.tile_2" 
                                        attr={{ alt: video.Title+ ' - Dacha', class:'' }} 
                                        imagetransformresult={processedImages} 
                                        id={video.id}/> */}
                                        <ImageModule 
                                                ImageSrc={video?.Image } 
                                                attr={{ alt: video?.Title +'Off Plan Gallery - Dacha', class: '' }} 
                                                ggfx_results={video?.ggfx_results} 
                                                imagename="news-items.Tile_Image.tile_2"
                                                strapi_id={video?.id} 
                                        />
                                        {video.Embed_Video_URL &&
                                            <div className="banner-btn">
                                                <PlayVideo url={video.Embed_Video_URL}  
                                                />
                                            </div>
                                        }
                                    </div>
                                    <div className="newsletter-info">
                                        <div className="time-info">
                                            <i className="icon-clock">
                                            </i>
                                            {moment(video.createdAt).format("DD/MM/YYYY")}
                                        </div>
                                        <h4>{video.Title}  </h4>
                                    </div>
                                </div>
                            )
                        })}
                    </Row>

                </Container>

            </div>
        </section>
    )
}
export default Videos